define(function(require, exports, module) {
    'use strict';

    var Configuration = require('modules/configuration/configuration');
    var Class = require('Class');
    var themeConfig = require('modules/configuration/theme.config');

    module.exports = Class.create(Configuration, {
        initialize: function() {
            Configuration.prototype.initialize.apply(this, arguments);

            // Prioritize values from Playtech.Variables
            // to have possibility to override config from Custom JS
            this.load(themeConfig);
            this.load(Playtech.Variables);
        }
    });
});
